<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content EC_width">
      <div class="leftContent">
        <div class="title"
             v-html="textFormat(articleinfo.biaoTi_CN)"></div>
        <div class="titleSub">
          <span class="marginRight5"
                v-html="articleinfo.zuoZhe_CN"></span>
        </div>
        <div class="introGray">
          <p v-html="articleinfo.zuoZheDiZhi_CN"></p>
          <div class="display_between">
            <p v-html="'DOI: ' + articleinfo.doi"></p>
            <div>
              <!-- <span class="wailianlink"><img src="/image/information/use01.png"></span>
                            <span class="wailianlink"><img src="/image/information/use02.png"></span>
                            <span class="wailianlink"><img src="/image/information/use03.png"></span>
                            <span class="wailianlink"><img src="/image/information/use04.png"></span>
                            <span class="wailianlink"><img src="/image/information/use05.png"></span> -->
            </div>
          </div>
        </div>
        <p style="line-height:2em"
           class="fontBold marginTop20"
           v-html="articleinfo.biaoTi_EN"></p>
        <p style="line-height:2em"
           v-html="articleinfo.zuoZheDiZhi_EN"></p>
        <div class="titleTageWrap marginTop30">
          <span class="tagTitle"
                :class="{ tagTitleActive: abstractIndex == 0 }"
                @click="tagAbstract(0)">摘要</span>
          <!-- <span class="tagTitle" :class="{tagTitleActive:abstractIndex==1}" @click="tagAbstract(1)">图/表</span> -->
          <span class="tagTitle"
                :class="{ tagTitleActive: abstractIndex == 1 }"
                @click="tagAbstract(1)">参考文献</span>
          <!-- <span class="tagTitle" :class="{tagTitleActive:abstractIndex==2}" @click="tagAbstract(2)">相关文章</span>
                    <span class="tagTitle" :class="{tagTitleActive:abstractIndex==3}" @click="tagAbstract(3)">图/表</span> -->
        </div>
        <div class="inforText">
          <p v-if="abstractIndex == 0 && articleinfo.pdF_WenJian != ''"
             style="cursor: pointer;"
             @click="pdfload(articleinfo)">
            <span>全文：</span>
            <span class="normalColor">PDF ({{ articleinfo.pdF_WenJianDaXiao }} KB )</span>
          </p>
          <p>
            <span class="fontBold marginRight5"
                  v-if="abstractIndex == 0">摘要:</span>
            <span class="fontBold marginRight5"
                  v-if="abstractIndex == 1">参考文献:</span>
            <!-- {{apiData.abstract.abstractCn}} -->
            <span v-if="abstractIndex == 0"
                  v-html="articleinfo.zhaiYao_CN"></span>
            <span v-if="abstractIndex == 1 && articleinfo.canKaoWenXian_CN != ''"
                  v-html="articleinfo.canKaoWenXian_CN"></span>
            <span v-else-if="abstractIndex == 1 && articleinfo.canKaoWenXian_CN == ''">暂无参考文献</span>
          </p>
          <p class="marginTop40"
             v-if="abstractIndex == 0">
            <span class="fontBold marginRight5">关键词:</span>
            <span class="marginRight5"
                  v-html="articleinfo.guanJianCi_CN"></span>
          </p>
          <div style="border-bottom: 1px solid #ccc;margin: 30px 0;"
               v-if="articleinfo.jiJinXiangMu_CN != ''"></div>
          <p v-if="articleinfo.jiJinXiangMu_CN != ''">
            <span class="fontBold marginRight5">基金项目:</span>
            <span class="marginRight5"
                  v-html="articleinfo.jiJinXiangMu_CN"></span>
          </p>
          <div style="border-bottom: 1px solid #ccc;margin: 30px 0;"
               v-if="articleinfo.zhaiYao_EN != '' && abstractIndex == 0"></div>
          <p v-if="articleinfo.zhaiYao_EN != '' && abstractIndex == 0">
            <span class="fontBold">Abstract:</span>
            <span v-html="articleinfo.zhaiYao_EN"></span>
          </p>
          <p class="marginTop40"
             v-if="articleinfo.guanJianCi_EN != '' && abstractIndex == 0">
            <span class="fontBold marginRight5">Key words:</span>
            <!-- <span class="marginRight5" v-for="(item,index) in apiData.abstract.keywordsEn" :key="index+'5'">{{item}}</span>-->
            <span class="marginRight5"
                  v-html="articleinfo.guanJianCi_EN"></span>
          </p>
          <p v-if="articleinfo.jiJinXiangMu_EN != ''">
            <span class="fontBold marginRight5">Funding:</span>
            <span class="marginRight5"
                  v-html="articleinfo.jiJinXiangMu_EN"></span>
          </p>
          <div style="border-bottom: 1px solid #ccc;margin: 30px 0;"></div>
          <p class="fontBold">
            引用文本
          </p>
          <!-- <p v-for="(item,index) in apiData.abstract.quote" :key="index+'7'">
                        {{item}}
                    </p> -->
          <P>{{ textFormat(articleinfo.suoYin_CN) }}</P>
          <P>{{ textFormat(articleinfo.suoYin_EN) }}</P>
          <!-- <div style="border-bottom: 1px solid #ccc;margin: 30px 0;"></div> -->
          <!-- <p>链接文本</p> -->
          <!-- <p v-for="(item,index) in apiData.abstract.linktext" :key="index+'8'"><a class="normalColor" href="javascript:;">{{item}}</a></p> -->
          <div class="downInfor marginTop40">
            <p>本文为本站原创或整理，仅代表作者本人的观点，与本网站立场无关。如内容和图片的著作权存在异议，请及时联系我们（官方邮箱chinagpweb@chinagp.net）。</p>
          </div>
        </div>
        <div class="timeLine">
          <div class="flex1 display_between">
            <div class="display_center tipsHover"
                 v-if="lastNew.biaoTi_CN != ''">
              <div class="page_btn"
                   style="margin-right: 10px;">
                &lt;
              </div>
              <div @click="lastnextclk(lastNew)">
                <a href="javascript:;"
                   class="page_btn_active_link">
                  <span style="font-weight: bold;">上一篇：</span>
                  {{ ellipsis(textFormat(lastNew.biaoTi_CN), 18) }}
                </a>
              </div>
            </div>
            <div class="display_center tipsHover"
                 v-if="nextNew.biaoTi_CN != ''">
              <div @click="lastnextclk(nextNew)">
                <a href="javascript:;"
                   class="page_btn_active_link">
                  <span style="font-weight: bold;">下一篇：</span>
                  {{ ellipsis(textFormat(nextNew.biaoTi_CN), 18) }}
                </a>
              </div>
              <div class="page_btn page_btn_active"
                   style="margin-left: 10px;">
                &gt;
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightVideoList">
        <div class="rightVedioTitle display_between">
          <div class="leftTitle">相关课程推荐</div>
          <div>
            <!-- <a href="javascript:;"><img src="/image/index/moreimg.png" class="marginRight5">更多</a> -->
          </div>
        </div>
        <div class="videoWrap marginBottom30"
             style="cursor: pointer;"
             v-for="(item, index) in recommendCourseList"
             :key="index + '9'"
             @click="courseclick(item)">
          <!-- <video src="" controls="controls">
                        当前浏览器不支持 video直接播放，点击这里下载视频： <a href="myvideo.webm">下载视频</a>
                    </video> -->
          <img :src="item.acr_PictResUrl"
               width="300"
               height="169" />
          <div class="videoTitle ">
            {{ item.title }}
          </div>
        </div>
        <div v-if="recommendArticleList != null">
          <div class="rightVedioTitle display_between">
            <!-- <div class="leftTitle">作者相关文章</div> -->
            <div class="leftTitle">相关研究</div>
          </div>
          <div class="videoArtItem"
               v-for="(item, index) in recommendArticleList"
               :key="index + '10'"
               @click="lastnextclk(item)">
            <a href="javascript:;">
              {{ textFormat(item.biaoTi_CN) }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from '../home/breadcrumbPage';
import $ from 'jquery';
export default {
  name: 'litedetails',
  data () {
    return {
      // 摘要默认index
      abstractIndex: 0,
      apiData: {
        title: {},
        abstract: {},
        course: {},
        relevant: {}
      },
      /**tianlianpei */
      articleinfo: {},
      lastNew: {
        id: 0,
        biaoTi_CN: '',
        nian: 0,
        qi: 0
      },
      nextNew: {
        id: 0,
        biaoTi_CN: '',
        nian: 0,
        qi: 0
      },
      year: '',
      period: '',
      recommendarticleinfo: [], //推荐课程
      recommendCourseList: [],
      recommendArticleList: []
    };
  },
  methods: {
    // 切换事件
    tagAbstract (index) {
      this.abstractIndex = index;
    },
    /**tianlianpei */
    /**根据id获取文献详情数据 */
    GetArticleInfoPageList (ID) {
      let _this = this;
      _this.$loading.show({
        text: 'loading....',
        textStyle: {
          fontSize: '18px',
          color: '#0b8686'
        }
      });
      _this.lastlist = [];
      _this.nextlist = [];
      this.httphelper
        .post('/api/ArticleApi/GetArticleInfoPageList', {
          year: _this.year.toString(),
          period: _this.period,
          id: Number(ID),
          keywords: '',
          recommendNumber: 0
        })
        .then(res => {
          this.$loading.hide();
          if (res.data.code == 200) {
            //年卷树结构数据
            if (res.data.data.gpSiteArticleInfoViews.length > 0) {
              _this.articleinfo = res.data.data.gpSiteArticleInfoViews[0];
            }
            let lastNew = res.data.data.lastNextPieceViews[0] || null;
            if (lastNew != null) _this.lastNew = res.data.data.lastNextPieceViews[0];
            let nexnew = res.data.data.lastNextPieceViews[1] || null;
            if (nexnew != null) _this.nextNew = res.data.data.lastNextPieceViews[1];
            //去掉html标签
            let keywork = _this.articleinfo.guanJianCi_CN.replace(/<[^>]+>/g, '');
            let reg1 = new RegExp('；', 'g'); //g代表全部
            let reg2 = new RegExp(';', 'g'); //g代表全部
            keywork = JSON.stringify(keywork).replace(reg1, ',');
            keywork = JSON.stringify(keywork).replace(reg2, ',');
            _this.GetArticleRecommendPageList(keywork.replace(';', ',').replace('；', ','));
            _this.GetCourseRecommendPageList(keywork.replace(';', ',').replace('；', ','));
          }
        });
    },
    /**相关推荐 */
    GetArticleRecommendPageList (keywords) {
      let _this = this;
      _this.articleList = [];
      _this.httphelper
        .post('/api/ArticleApi/GetArticleRecommendPageList', {
          year: '',
          period: '',
          id: 0,
          keywords: keywords,
          recommendNumber: 5
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.recommendArticleList = res.data.data;
          }
        });
    },
    /**相关课程推荐 */
    GetCourseRecommendPageList (keywords) {
      let _this = this;
      _this.recommendCourseList = [];
      _this.httphelper
        .post('/api/ArticleApi/GetCourseRecommendPageList', {
          year: '',
          period: '',
          id: 0,
          keywords: keywords,
          recommendNumber: 5
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.recommendCourseList = res.data.data;
          }
        });
    },
    /** 更新PDF下载次数 */
    uppdfload (id) {
      let _this = this;
      _this.articleList = [];
      _this.httphelper.post('/api/ArticleApi/UpdPdfClickCount', {
        id: id
      });
    },
    getUrlKey (url, name) {
      return (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ''])[1].replace(/\+/g, '%20') || null;
    },
    /**pdf下载 */
    pdfload (item) {
      this.uppdfload(item.id);
      if (item.pdF_WenJian.indexOf('http://') > -1 || item.pdF_WenJian.indexOf('https://') > -1) {
        let url = item.pdF_WenJian;
        var datajson = { attachType: 'PDF', id: this.getUrlKey(item.pdF_WenJian, 'id') };
        var $iframe = $('<iframe />');
        var $form = $('<form  method="get" target="_self"/>');
        $form.attr('action', url); //设置get的url地址
        for (var key in datajson) {
          //设置请求的参数
          $form.append('<input type="hidden"  name="' + key + '" value="' + datajson[key] + '" />');
        }
        $iframe.append($form);
        $(document.body).append($iframe);
        $form[0].submit(); //提交表单
        $iframe.remove(); //移除框架
      } else {
        let url = 'https://www.chinagp.net/CN/article/downloadArticleFile.do';

        var datajson = { attachType: 'PDF', id: item.id };
        var $iframe = $('<iframe />');
        var $form = $('<form  method="get" target="_self"/>');
        $form.attr('action', url); //设置get的url地址
        for (var key in datajson) {
          //设置请求的参数
          $form.append('<input type="hidden"  name="' + key + '" value="' + datajson[key] + '" />');
        }
        $iframe.append($form);
        $(document.body).append($iframe);
        $form[0].submit(); //提交表单
        $iframe.remove(); //移除框架
      }
    },
    lastnextclk (item) {
      this.$router.push({
        path: '/journal/magazinejournal/magazinejournaldetail',
        query: {
          nian: item.nian,
          qi: item.qi,
          id: item.id
        }
      });
      window.location.reload();
    },
    textFormat (val) {
      if (val) {
        return val
          .replace(/<[^>]+>/g, '')
          .replace(/&mdash;/g, '')
          .replace(/&ldquo;/g, '')
          .replace(/&rdquo;/g, '')
          .replace(/&gamma;/g, '')
          .replace(/&beta;/g, '')
          .replace(/#br#/g, '')
          .replace(/&quot;/g, '')
          .replace(/&kappa;/g, '')
          .replace(/&nbsp;/g, '');
      }
    },
    /** 课程跳转*/
    courseclick (item) {
      let id = item.courseInfoId == 0 ? item.id : item.courseInfoId;
      let url = this.httphelper.IsDebugCgphome() + '/detail?courseId=' + id;
      window.open(url);
    }
  },
  created () {
    this.year = this.$route.query.nian;
    this.period = this.$route.query.qi;
    this.$route.matched.forEach(element => {
      if (element.name == this.$route.name) {
        element.meta.breadcrumbTitle = '[' + this.year + '年' + this.period + '期]' + element.meta.breadcrumbTitle;
      }
    });
    this.GetArticleInfoPageList(this.$route.query.id);
  },
  components: {
    breadcrumbPage
  }
};
</script>

<style scoped>
.content {
    padding-top: 30px;
    display: flex;
    flex: 1;
    padding-bottom: 40px;
}

.leftContent {
    flex: 1;
}

.title {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 30px;
}

.titleSub {
    font-size: 14px;
    font-weight: bold;
}

.introGray {
    color: #8c8c8c;
    font-size: 14px;
    margin-top: 18px;
    border-bottom: 1px solid #333;
    padding-bottom: 18px;
    line-height: 28px;
}

.titleTageWrap {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 40px;
}

.tagTitle {
    display: inline-block;
    height: 100%;
    font-size: 18px;
    cursor: pointer;
    font-weight: bold;
    position: relative;
    margin-right: 20px;
}

.tagTitle ~ .tagTitle::before {
    content: '/';
    margin: 0 14px;
    color: #ddd;
    position: absolute;
    left: -28px;
}

.tagTitleActive {
    border-bottom: 1px solid #0b8686;
    color: #0b8686;
}

.inforText {
    line-height: 2em;
}

.downInfor {
    color: #ccc;
    border-bottom: 1px solid #333;
}

.timeLine {
    height: 80px;
    line-height: 80px;
}

.page_btn {
    color: #999;
    cursor: pointer;
    display: inline-block;
    width: 22px;
    height: 22px;
    text-align: center;
    line-height: 22px;
    border-radius: 22px;
    border: 1px solid #ccc;
}

/* 右侧样式设置 */
.rightVideoList {
    width: 310px;
}

/* 右面视频列表样式 */
.rightVideoList {
    margin-left: 50px;
}

.rightVedioTitle {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
}

.leftTitle {
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #333;
}

.videoWrap video {
    width: 100%;
}

.videoTitle {
    font-size: 16px;
    margin-top: 12px;
}

.videoArtItem {
    padding-bottom: 20px;
    border-bottom: 1px solid #ddd;
    position: relative;
    margin-bottom: 14px;
    padding-left: 10px;
}

.videoArtItem a {
    font-size: 16px;
}

.videoArtItem::before {
    content: '|';
    color: #0b8686;
    position: absolute;
    left: -5px;
    font-weight: bold;
    font-size: 20px;
    top: -4px;
}

.tipsHover:hover .page_btn_active_link {
    color: #0b8686;
}

.tipsHover:hover .page_btn {
    background: #0b8686;
    color: #fff;
    border: 1px solid #0b8686;
}
.wailianlink {
    display: inline-block;
    width: 25px;
    height: 25px;
    background: #d3d5d5;
    border-radius: 5px 0px 5px 0px;
    text-align: center;
    line-height: 25px;
    cursor: pointer;
    margin-right: 5px;
}
.wailianlink:hover {
    background: #0b8586;
}
</style>
